module.exports = __webpack_public_path__ + "img/logo.3a8a0329.png";